export default "__VITE_PUBLIC_ASSET__23dc2d43__"